import { useSongRemixes } from '../../arp-media-queries'
import { ArpTableContextData } from '../components'

export const useSongRemixTable = (id: number): ArpTableContextData<any> => {
  const {
    data: rawData,
    fetchNextPage,
    hasNextPage: hasMore,
    status: rawStatus
  } = useSongRemixes({ songId: id })
  const data = rawData?.pages.flatMap((page) => page.data) || []
  const status = rawStatus === 'success' ? 'ready' : rawStatus
  const updateFilters = () => {}
  return {
    data,
    hasMore,
    status,
    nextPage: fetchNextPage,
    updateFilters,
    filters: {},
    defaultFilters: {}
  }
}
